// extracted by mini-css-extract-plugin
export default {"table":"styles_table__InQgB","table-body":"styles_table-body__gIH8R","resized":"styles_resized__y7pmV","address":"styles_address__pT1fw","state":"styles_state__jFZOt"};